export function DescricaoAtributo(label): ClassDecorator {
  return function decorator(target: any) {
    target.descricaoAtributos = label;
  }
}

// function DescricaoAtributoPropertie(string) {
//   return function (target) {
//     Object.defineProperty(
//         target.prototype,
//         'descricaoAtributo',
//         {value: () => string.descricaoAtributo}
//     )
//   }
// }
